var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mintage-wrapper" },
    [
      _c("sec-title", { attrs: { isShowHelp: false } }),
      _vm._v(" "),
      _c("mintage", { on: { fetchTokenList: _vm.fetchTokenList } }),
      _vm._v(" "),
      _c("tokenList", { ref: "tokenListDom" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }